import { combineReducers } from 'redux';

export function error(state = null, action) {
  switch (action.type) {
    case 'QUESTIONBANK_SEARCH_ERROR':
      return action.error;

    case 'QUESTIONBANK_SEARCH_RESET':
      return null;

    default:
      return state;
  }
}

export function loading(state = false, action) {
  switch (action.type) {
    case 'QUESTIONBANK_SEARCH_LOADING':
      return action.loading;

    case 'QUESTIONBANK_SEARCH_RESET':
      return false;

    default:
      return state;
  }
}

export function retrieved(state = null, action) {
  switch (action.type) {
    case 'QUESTIONBANK_SEARCH_SUCCESS':
      return action.retrieved;

    case 'QUESTIONBANK_SEARCH_RESET':
      return null;

    default:
      return state;
  }
}

export function selectedCategories(state = [], action) {
  switch (action.type) {
    case 'QUESTIONBANK_CATEGORIES_SELECT':
      return action.selectedCategories;
    default:
      return state;
  }
}


export default combineReducers({ error, loading, retrieved, selectedCategories });
